import { useState } from 'react';
import PropTypes from 'prop-types';
import './Accordion.css';

function AccordionRow({
  name,
  meta,
  count,
  subtotal,
  status,
  defaultOpen = false,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`accordion-row${open ? ' accordion-row--open' : ''}`}>
      <button
        type="button"
        className="accordion-head"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span className="accordion__chevron">›</span>
        <div className="accordion__info">
          <div className="accordion__name">{name}</div>
          {meta && <div className="accordion__meta">{meta}</div>}
        </div>
        {count != null && <span className="accordion__count">{count}</span>}
        {subtotal != null && (
          <span className="accordion__subtotal">{subtotal}</span>
        )}
        {status === 'ok' && (
          <span className="accordion__status accordion__status--ok">
            <span className="accordion__status-dot" />
            OK
          </span>
        )}
        {status === 'err' && (
          <span className="accordion__status accordion__status--err">
            <span className="accordion__status-dot" />
            Error
          </span>
        )}
      </button>
      {children && <div className="accordion__body">{children}</div>}
    </div>
  );
}

AccordionRow.propTypes = {
  name: PropTypes.string.isRequired,
  meta: PropTypes.string,
  count: PropTypes.string,
  subtotal: PropTypes.string,
  status: PropTypes.oneOf(['ok', 'err']),
  defaultOpen: PropTypes.bool,
  children: PropTypes.node,
};

function AccordionItem({ code, label, value }) {
  return (
    <div className="accordion__item">
      {code && <span className="accordion__item-ref">{code}</span>}
      <span className="accordion__item-label">{label}</span>
      <span className="accordion__item-value">{value}</span>
    </div>
  );
}

AccordionItem.propTypes = {
  code: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function Accordion({ children }) {
  return <div className="accordion">{children}</div>;
}

Accordion.propTypes = { children: PropTypes.node };

Accordion.Row = AccordionRow;
Accordion.Item = AccordionItem;

export default Accordion;
